import { useQuery } from "react-query";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import { KontakReferensiResponse } from "../../../../models/KontakReferensi";
import { allKontakReferensiKey } from "../../mutations/KontakReferensi/useFetchKontakReferensi";
import ApiClient from "../../../apiClient";

export async function allKontakReferensi(): Promise<KontakReferensiResponse[]> {
    const res = await ApiClient.get(`/AllReferenceContact`);
    return res.data;
}

export default function useFetchAllKontakReferensi() {
    return useQuery([allKontakReferensiKey], queryWrapper(allKontakReferensi));
}
